import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum TradeSettingsFormErrorStatesEnum {
    UpdatePlatformSubscriptionsFailed = ErrorStateScheduleEnum.TradeSettingsFormStatesStartIndex,
    UpdateTradingCategoryFailed,
    UpdateClientAliasFailed,
    UpdateTradingCategoryOrClientAliasFailed
}
